import { memo } from 'react';
import { Alert, Button, SpaceBetween } from '@amzn/awsui-components-core';

import { useViewModeStatePanelViewModel } from './ViewModeStatePanelViewModel';

/**
 * Read-only state panel shown on the content view page. Renders an Edit
 * button that locks the content and redirects to the edit page for users
 * whose role may edit; otherwise renders nothing (the publication metadata
 * above suffices).
 */
const ViewModeStatePanel = memo(function ViewModeStatePanel() {
  const vm = useViewModeStatePanelViewModel();

  if (!vm.canEdit) return null;

  return (
    <SpaceBetween size="xs" direction="vertical">
      <Button
        variant="primary"
        fullWidth
        iconName="lock-private"
        disabled={vm.isEditDisabled}
        loading={vm.isEditInProgress}
        onClick={vm.editContent}
        data-testid="side-panel-edit"
      >
        Edit content
      </Button>
      {vm.editError && <Alert type="error">{vm.editError}</Alert>}
    </SpaceBetween>
  );
});

export { ViewModeStatePanel };
